var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextfield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.587,
    height: 48.657,
    viewBox: "0 0 235.587 48.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Textfield",
    transform: "translate(-47.648 -142.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_564",
    "data-name": "Tracciato 564",
    d: "M47.674,139.024l232.806,6.608,1.562,41.789-234.368-2.9Z",
    transform: "translate(1.193 3.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_565",
    "data-name": "Tracciato 565",
    d: "M46.485,138.771l232.806,6.608-224.955-.227-6.56,39.2Z",
    transform: "translate(1.163 3.471)",
    fill: "#b3b3b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextfield);
export default __webpack_public_path__ + "static/media/Textfield.e483890f4311d4c508e846f7ce512936.svg";
export { ForwardRef as ReactComponent };